import { css } from '@emotion/react';
import cn from 'classnames';
import { type ForwardedRef, forwardRef, memo } from 'react';

import { TYPOGRAPHY_VARIANTS } from '../../../config/typography/constants';
import { Link, type LinkProps } from '../link/Link';

export type TextLinkProps = LinkProps;

export const TextLinkBase = forwardRef(
  (
    { className = null, isDisabled = false, ...props }: TextLinkProps,
    ref: ForwardedRef<HTMLAnchorElement | HTMLElement>,
  ) => (
    <Link
      {...props}
      isDisabled={isDisabled}
      ref={ref}
      className={cn(className, { isDisabled })}
      css={(theme) => css`
        text-decoration: underline;
        color: ${theme.colors.primary[500]};

        ${theme.typography[TYPOGRAPHY_VARIANTS.BODY_MEDIUM_REGULAR]};

        transition: ${theme.transitions.default('color')};

        &.isDisabled {
          color: inherit;
          text-decoration: none;
        }

        &:hover {
          color: ${theme.colors.primary[400]};
        }

        &:visited {
          color: ${theme.colors.tertiary[500]};
        }
      `}
    />
  ),
);

TextLinkBase.displayName = 'TextLink';

export const TextLink = memo(TextLinkBase);
